<script setup lang="ts">
import { useTitle } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { computed, watch, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView, useRouter } from 'vue-router'
import { toast, Toaster } from 'vue-sonner'

import { useTheme } from './composables/useTheme'
import { useUserStore } from './stores/user'

const router = useRouter()
const { t } = useI18n()
const userStore = useUserStore()
const { isAuthenticated } = storeToRefs(userStore)
const { mode } = useTheme()
const toasterTheme = computed<'light' | 'dark' | 'system'>(() => (mode.value === 'auto' ? 'system' : mode.value))

watch(isAuthenticated, (isAuth, wasAuth) => {
  if (wasAuth && !isAuth) {
    toast.error('请重新登录')
    router.push('/login')
  }
})

const title = useTitle()
watchEffect(() => {
  title.value = t('common.appName')
})
</script>

<template>
  <div class="min-h-screen bg-background text-foreground transition-colors duration-200">
    <Toaster position="top-right" :expand="true" :rich-colors="true" :theme="toasterTheme" />
    <RouterView v-slot="{ Component }" :key="$route.fullPath">
      <KeepAlive>
        <component :is="Component" />
      </KeepAlive>
    </RouterView>
  </div>
</template>
